import { MenuComponent } from './menu/menu.component';
import { MenuTabComponent } from './menu-tab/menu-tab.component';
import { MenuLinkComponent } from './menu-link/menu-link.component';
import { NavigationPaneComponent } from './navigation-pane/navigation-pane.component';
import { SubMenuComponent } from './sub-menu/sub-menu.component';
import { SubMenuItemComponent } from './sub-menu-item/sub-menu-item.component';

export const COMPONENTS = [
	MenuComponent,
	MenuTabComponent,
	MenuLinkComponent,
	NavigationPaneComponent,
	SubMenuComponent,
	SubMenuItemComponent,
];
